import React from "react";
import styled from "styled-components";

const TabsRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const TabBtn = styled.button`
  padding: 10px 16px;
  border-radius: 12px;
  background: ${({ active }) => (active ? "#00f7d225" : "#0d1220")};
  border: 1px solid #1f2937;
  color: #5ce9ff;
  cursor: pointer;
`;

function TabsPRO({ activeTab, setActiveTab }) {
  const tabs = ["details", "documents", "trace", "seller", "reviews"];
  return (
    <TabsRow>
      {tabs.map((t) => (
        <TabBtn
          key={t}
          active={activeTab === t}
          onClick={() => setActiveTab(t)}
        >
          {t.toUpperCase()}
        </TabBtn>
      ))}
    </TabsRow>
  );
}

export default TabsPRO;

